import {
  DESEJA_ACOMPANHAR_OPTIONS,
  RELATADO_LIDER_OPTIONS,
  STATUS_ATUAL_OPTIONS,
} from '../../shared/constants';

export const getFilterConfig = ({ motivoOptions = [], tagOptions = [] } = {}) => [
  {
    id: 'protocolo',
    type: 'text',
    label: 'Protocolo',
    placeholder: 'Digite o protocolo',
  },
  {
    id: 'motivoId',
    type: 'select',
    label: 'Motivo',
    placeholder: 'Selecione o motivo',
    options: motivoOptions,
  },
  {
    id: 'tagId',
    type: 'select',
    label: 'Tag',
    placeholder: 'Selecione a tag',
    options: tagOptions,
  },
  {
    id: 'desejaAcompanhar',
    type: 'select',
    label: 'Deseja acompanhar',
    placeholder: 'Selecione',
    options: DESEJA_ACOMPANHAR_OPTIONS,
  },
  {
    id: 'relatadoLiderStatus',
    type: 'select',
    label: 'Relatado lider status',
    placeholder: 'Selecione',
    options: RELATADO_LIDER_OPTIONS,
  },
  {
    id: 'statusAtual',
    type: 'select',
    label: 'Status atual',
    placeholder: 'Selecione',
    options: STATUS_ATUAL_OPTIONS,
  },
  {
    id: 'relato',
    type: 'text',
    label: 'Relato',
    placeholder: 'Digite parte do relato',
    fullWidth: true,
  },
  {
    id: 'dataCriacaoInicial',
    type: 'date',
    label: 'Data inicial',
  },
  {
    id: 'dataCriacaoFinal',
    type: 'date',
    label: 'Data final',
  },
];
